import heroscroll from './features/heroscroll';
import cookiebanner from './features/cookiebanner';
import adsource from './features/adsource';

$(() => {
    heroscroll();
    cookiebanner('bod-cookie-banner');
    adsource();
});



// WEBPACK FOOTER //
// ../Resources/Private/JavaScript/bod-main.js